import { AppSettings } from "../../common/types/appSettings";
import { initialState } from "../store/initialState";
import { AnyAction } from "redux";
import appSettingsReducer from "src/common/reducers/appSettingsReducer";
import { internalActionKeys } from "../actions/internalActionKeys";

export default function internalAppSettingsReducer(
  state: AppSettings = initialState.appSettings,
  action: AnyAction
): AppSettings {
  switch (action.type) {
    case internalActionKeys.SAVE_APP_SETTINGS_SUCCESS:
      return { ...action.appSettings };
    case internalActionKeys.SAVE_APP_SETTING_LOGO:
      const settings = { ...state };
      settings.logoUrl = action.logoUrl;
      return settings;
    case internalActionKeys.SAVE_APP_SETTINGS_FAILURE:
      return state;
    default:
      return appSettingsReducer(state, action);
  }
}
